import React from "react";
import styled from "styled-components";

const Input = styled.input`
  width: ${props => props.width}px !important;
  padding: 0px 5px;
  border: 1px solid #ccc;
`;
// height: 25px !important;

export default function SmallNumberInput({ onChange, value, width, onArrowUp, onArrowDown }) {
  const handleKeyDown = e => {
    if (onArrowUp && e.keyCode === 38) {
      onArrowUp();
    }
    if (onArrowDown && e.keyCode === 40) {
      onArrowDown();
    }
  };

  return (
    <Input
      width={width}
      onKeyDown={handleKeyDown}
      type="text"
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
}
